import { template as template_17eb416d8408406cb0e0355297ac64d7 } from "@ember/template-compiler";
import RouteTemplate from 'ember-route-template';
export default RouteTemplate(template_17eb416d8408406cb0e0355297ac64d7(`
<div class="landing-page">
  <img src="/images/epicor-logo-blue.png" />
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
}));
